import {gtm_code} from '../../../envirement';

const ScriptStore = [
    {
      name: 'cookiebot',
      src: 'https://consent.cookiebot.com/uc.js',
      async: false
    },
    {
      name: 'cookiebot-personal',
      src: 'https://consent.cookiebot.com/c3155626-7a33-44fe-a1c1-6e4dccbd3132/cd.js',
      async: true
    }
  ];

const scriptsToLoad = ScriptStore.reduce((acc, script) => {
    return {...acc, [script.name] : {loaded: false, src: script.src } };
}, {})

export const loadGtmScript = () => {
    const script = document.createElement('script');

    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtm_code;
    document.head.prepend(script);
}

export const load = (...scriptNames) => {
    const promises = [];

    scriptNames.forEach((scriptName) => promises.push(loadScript(scriptName, scriptsToLoad)));

    return Promise.all(promises);
}

function loadScript(name, scripts) {
    return new Promise((resolve) => {
      if (!scripts[name].loaded) {
        let script = document.createElement('script');

        script.type = 'text/javascript';
        script.src = scripts[name].src;
        script.async = scripts[name].async;
        script.setAttribute('data-cbid', 'c3155626-7a33-44fe-a1c1-6e4dccbd3132');
        script.setAttribute('data-blockingmode', 'auto');

        if (script.readyState) {
          script.onreadystatechange = () => {
            if (script.readyState === "loaded" || script.readyState === "complete") {
              script.onreadystatechange = null;

              scripts[name].loaded = true;

              resolve({ script: name, loaded: true, status: 'Loaded' });
            }
          };
        } else {
          script.onload = () => {
            scripts[name].loaded = true;

            resolve({ script: name, loaded: true, status: 'Loaded' });
          };
        }

        script.onerror = (error) => resolve({ script: name, loaded: false, status: 'Loaded' });

        document.getElementById('root').appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      }
    });
  }